<template>
  <!-- <div class="card">
    <div class="card-body">
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        "
        class="mb-5"
      >
        <p style="font-size: 28px; font-weight: 600; color: #333333">
          Agregar prestador
        </p>
        <label style="text-align: start; margin-bottom: 0; margin-top: 6px">
          Número de Cédula:
        </label>
        <div style="display: flex; gap: 12px">
          <input
            required
            placeholder="Número de Cédula Ej: 0912345678"
            class="form-control"
            style="width: fit-content; min-width: 300px"
            type="text"
            autocomplete="off"
            maxlength="10"
            @input="validateCedula"
            v-model="idNumber"
          />
          <button
            :disabled="requesting || !validId"
            id="btn-request"
            type="button"
            @click="requestDni"
            class="btn btn-primary"
            style="height: fit-content"
          >
            <i class="fas fa-search"></i>
          </button>
        </div>
        <label style="text-align: start; margin-bottom: 0; margin-top: 6px">
          Número de RUC:
        </label>
        <div style="display: flex; gap: 12px">
          <input
            required
            placeholder="Número de Cédula Ej: 0912345678001"
            class="form-control"
            style="width: fit-content; min-width: 300px"
            type="text"
            autocomplete="off"
            maxlength="13"
            @input="validateRuc"
            v-model="rucNumber"
          />
          <button
            :disabled="requesting || !validRuc"
            id="btn-request-ruc"
            type="button"
            @click="requestRuc"
            class="btn btn-primary"
            style="height: fit-content"
          >
            <i class="fas fa-search"></i>
          </button>
          <button
            id="btn-request-ruc"
            @click="requestRuc"
            :disabled="requesting || !validRuc"
            class="btn btn-primary"
          >
            <i v-if="requesting" class="fas fa-spinner fa-pulse"></i>
            <i v-else class="fas fa-search"></i>
          </button>
        </div>
        <div
          style="margin: 12px 0; display: flex; gap: 12px"
          v-if="requestData"
        >
          <p class="form-control" style="width: fit-content; min-width: 300px">
            {{ requestData.name }}
          </p>

          <label>Cédula</label>
          <input type="text" class="form-control" v-model="providerDni2" />

          <label>Nombres</label>
          <input type="text" class="form-control" v-model="providerName2" />

          <label>Asignar a Ejecutivo</label>
          <v-select
            v-model="selectedEjecutivo"
            placeholder="Seleccionar Ejecutivo"
            class="my-custom-v-select"
            label="displayName"
            :options="ejecutivos"
            @option:selected="selectEjecutivo"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
            </template>
          </v-select>

          <label>Asignar Comercial</label>
          <v-select
            v-model="selectedComercial"
            placeholder="Seleccionar Comercial"
            class="my-custom-v-select"
            label="displayName"
            :options="comerciales"
            @option:selected="selectComercial"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
            </template>
          </v-select>

          <div class="col-12 text-end mt-4">
            <button class="btn btn-secondary me-2" @click="showModal = false">
              <i class="fas fa-times me-2"></i>Cancelar
            </button>
            <button class="btn btn-primary" @click="updateProvider">
              <i class="fas fa-save me-2"></i>Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Edit Provider Modal -->
  <VueFinalModal
    v-model="showModal"
    :esc-to-close="true"
    @closed="showModal = false"
    class="modal-container"
    content-class="modal-content"
  >
    <div class="modal__content">
      <div class="row">
        <div class="col-11">
          <h5 class="modal-title">Editar Prestador</h5>
        </div>
        <div class="col-1 text-end">
          <button
            type="button"
            class="btn-close"
            @click="showModal = false"
          ></button>
        </div>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-6">
          <label class="form-label fw-semibold">Cédula:</label>
          <input
            type="text"
            class="form-control"
            v-model="providerDni2"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label fw-semibold">Nombres:</label>
          <input type="text" class="form-control" v-model="providerName2" />
        </div>

        <div class="col-md-12">
          <label class="form-label fw-semibold">Asignar a Ejecutivo:</label>
          <v-select
            v-model="selectedEjecutivo"
            placeholder="Seleccionar Ejecutivo"
            class="my-custom-v-select"
            label="displayName"
            :options="ejecutivos"
            @option:selected="selectEjecutivo"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
            </template>
          </v-select>
        </div>

        <div class="col-md-12">
          <label class="form-label fw-semibold">Asignar Patrocinador:</label>
          <v-select
            v-model="selectedComercial"
            placeholder="Seleccionar Comercial"
            class="my-custom-v-select"
            label="displayName"
            :options="comerciales"
            @option:selected="selectComercial"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
            </template>
          </v-select>
        </div>

        <div class="col-12 text-end mt-4">
          <button class="btn btn-secondary me-2" @click="showModal = false">
            <i class="fas fa-times me-2"></i>Cancelar
          </button>
          <button class="btn btn-primary" @click="updateProvider">
            <i class="fas fa-save me-2"></i>Actualizar
          </button>
        </div>
      </div>
    </div>
  </VueFinalModal>

  <div class="card shadow-sm rounded-3">
    <div class="card-body">
      <div class="mb-4">
        <h6
          style="background: #0078be !important"
          class="card-title bg-primary text-white w-100 p-2 mb-3 rounded"
        >
          AGREGAR PRESTADOR
        </h6>
      </div>

      <div class="row g-3 mb-4">
        <div class="col-md-3">
          <label class="form-label fw-semibold">
            <i class="fas fa-file-alt me-2 text-primary"></i>Tipo de Documento:
          </label>
          <select class="form-select" v-model="documentType">
            <option value="cedula">Cédula</option>
            <option value="ruc">RUC</option>
          </select>
        </div>

        <div class="col-md-9">
          <label class="form-label fw-semibold">
            <i class="fas fa-id-card me-2 text-primary"></i>Número de
            {{ documentType === "cedula" ? "Cédula" : "RUC" }}:
          </label>
          <div class="input-group">
            <input
              required
              :placeholder="
                documentType === 'cedula'
                  ? 'Ej: 0912345678'
                  : 'Ej: 1234567890123'
              "
              class="form-control"
              type="text"
              autocomplete="off"
              @input="validateIdNumber"
              @keypress="validateIdNumber"
              v-model="idNumber"
            />
            <button
              :disabled="requesting || !validId"
              id="btn-request"
              type="button"
              @click="documentType === 'cedula' ? requestDni() : requestRuc()"
              class="btn btn-primary"
            >
              <i class="fas fa-search"></i>
            </button>
          </div>
          <small v-if="message" class="text-danger">{{ message }}</small>
        </div>

        <div class="col-md-6" v-if="requestData">
          <label class="form-label fw-semibold">
            <i class="fas fa-user me-2 text-primary"></i>Nombre:
          </label>
          <input
            type="text"
            class="form-control"
            :value="requestData.name"
            readonly
          />
        </div>

        <div class="col-md-12" v-if="requestData">
          <label class="form-label fw-semibold">
            <i class="fas fa-user-tie me-2 text-primary"></i>Asignar a
            Ejecutivo:
          </label>
          <v-select
            v-model="selectedEjecutivo"
            placeholder="Seleccionar Ejecutivo"
            class="my-custom-v-select"
            label="displayName"
            :options="ejecutivos"
            @option:selected="selectEjecutivo"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
            </template>
          </v-select>
        </div>

        <div class="col-md-12" v-if="requestData">
          <label class="form-label fw-semibold">
            <i class="fas fa-user-tie me-2 text-primary"></i>Asignar
            Patrocinador:
          </label>
          <v-select
            v-model="selectedComercial"
            placeholder="Seleccionar Comercial"
            class="my-custom-v-select"
            label="displayName"
            :options="comerciales"
            @option:selected="selectComercial"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
            </template>
          </v-select>
        </div>

        <div class="col-12 text-end" v-if="requestData">
          <button
            :disabled="adding"
            id="btn-add"
            type="button"
            @click="addProvider"
            class="btn btn-primary"
          >
            <i class="fas fa-plus me-2"></i>
            {{ adding ? "Agregando..." : "Agregar Prestador" }}
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="mb-0 fw-bold">
          <i class="fas fa-list me-2 text-primary"></i>LISTADO DE PRESTADORES
        </h6>
      </div>

      <div v-if="loading">
        <Skeletor :shimmer="true" height="40" width="100%" class="mb-2" />
        <Skeletor :shimmer="true" height="200" width="100%" />
      </div>

      <DataTable
        v-else
        :key="transactions.length"
        :columns="columns"
        :options="options"
        :data="transactions"
        class="table table-hover"
      >
        <thead class="table-light">
          <tr>
            <th style="width: 40px">#</th>
            <th style="width: 140px">Fecha</th>
            <th style="width: 150px">Cédula</th>
            <th style="width: 450px">Nombres</th>
            <th style="width: 400px">Ejecutivo</th>
            <th style="width: 400px">Email Ejecutivo</th>
            <th style="width: 150px">Hubspot Owner Id</th>
            <th style="width: 400px">Patrocinador</th>
            <th>Estado</th>
            <th>Acción</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import $ from "jquery";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";

DataTable.use(DataTablesCore);

export default {
  name: "ProvidersAdmin",
  components: { DataTable, VueFinalModal },
  props: ["tokenAuth"],
  data() {
    return {
      loading: true,
      providers: null,
      idNumber: "",
      rucNumber: "",
      message: null,
      validId: false,
      validRuc: false,
      requesting: false,
      requestData: null,
      adding: false,
      providerDni: null,
      providerName2: null,
      providerDni2: null,
      providerStatus: null,
      transactions: [],
      documentType: "cedula",
      selectedEjecutivo: null,
      selectedComercial: null,
      ejecutivos: [],
      comerciales: [],
      showModal: false,
      columns: [
        {
          data: null,
          render: function (data, type, row, meta) {
            const index = meta.row + 1;
            return index;
          },
        },
        { data: "dateFormatted" },
        { data: "providerDni" },
        { data: "providerName" },
        {
          data: null,
          render: function (data, type, row) {
            return row.ejecutivoName ? row.ejecutivoName : "";
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            return row.ejecutivoEmail ? row.ejecutivoEmail : "";
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            return row.hubspotOwnerId ? row.hubspotOwnerId : "";
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            return row.comercialName ? row.comercialName : "";
          },
        },
        {
          data: "providerStatus",
          render: function (data, type, row, meta) {
            const switchClass = row.providerStatus
              ? "form-check-input mt-1 form-check-input--active"
              : "form-check-input mt-1";
            let checkedAttribute = "";

            if (row.providerStatus == true) {
              checkedAttribute = "checked";
            } else {
              checkedAttribute = "";
            }

            return `
              <div class="form-switch text-center">
                      <input
                                      class="activarSwitch ${switchClass}"
                                      type="checkbox"                                        
                                      data-providerDni="${row.providerDni}"
                                      ${checkedAttribute}
                                  />
              </div>
        `;
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            const dataObject = encodeURIComponent(JSON.stringify(row)); // Codificar el JSON
            return `
                <div class="d-flex justify-content-center align-items-center ">                    
                    <i data-id="${dataObject}" data-action="edit" class="dataAction redes fas fa-edit" data-type="modificar" style="cursor:pointer; margin-right: 10px; color: #015183;"></i>                    
                </div>
            `;
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        autoWidth: false,
        deferRender: true,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [5, 15, 25, 35, 50, -1],
          [5, 15, 25, 35, 50, "All"],
        ],
        pageLength: 5,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Ingrese algún dato",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
        },
      },
    };
  },
  computed: {},
  watch: {
    idNumber(val) {
      if (val !== null && val !== undefined) {
        this.validateIdNumber();
        this.requestData = null;
      }
    },
    rucNumber(val) {
      if (val !== null && val !== undefined && val !== "") {
        this.validateRuc();
        this.requestData = null;
      }
    },
  },
  methods: {
    validateIdNumber() {
      // Check if idNumber is not null before processing
      if (!this.idNumber) {
        this.validId = false;
        this.message =
          this.documentType === "cedula"
            ? "La Cédula debe tener exactamente 10 dígitos."
            : "El RUC debe tener exactamente 13 dígitos.";
        return;
      }

      // Solo números
      this.idNumber = this.idNumber.replace(/\D/g, "");

      if (this.documentType === "cedula") {
        this.idNumber = this.idNumber.slice(0, 10);
        this.validId = this.idNumber.length === 10;
        this.message = this.validId
          ? null
          : "La Cédula debe tener exactamente 10 dígitos.";
      } else if (this.documentType === "ruc") {
        this.idNumber = this.idNumber.slice(0, 13);
        this.validId = this.idNumber.length === 13;
        this.message = this.validId
          ? null
          : "El RUC debe tener exactamente 13 dígitos.";
      }
    },

    validateRuc() {
      // Check if rucNumber is not null before processing
      if (!this.rucNumber) {
        this.validRuc = false;
        return;
      }

      // Solo números
      this.rucNumber = this.rucNumber.replace(/\D/g, "");

      // Limit to 13 digits
      this.rucNumber = this.rucNumber.slice(0, 13);

      // Validate RUC format (13 digits ending in 001)
      this.validRuc =
        this.rucNumber.length === 13 && this.rucNumber.endsWith("001");
    },

    requestDni() {
      document.getElementById("btn-request").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i> Consultando, espere...';
      this.requesting = true;
      this.$https
        .post("/consul/srg-verificar-persona", {
          dni: this.idNumber,
        })
        .then((response) => {
          if (response.data.code === 200 && response.data.preview?.validado) {
            this.requestData = {
              name: response.data.preview.nombre.trim(),
              type: "dni",
            };
          }
          if (response.data.code === 204) {
            this.$toast.error(response.data.message, {
              position: "top-right",
              max: 10,
            });
          }
          document.getElementById("btn-request").innerHTML =
            '<i class="fas fa-search"></i>';

          this.requesting = false;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error(error.data.message, {
            position: "top-right",
            max: 10,
          });
        });
    },
    requestRuc() {
      this.requesting = true;

      // Use rucNumber if available, otherwise use idNumber
      const rucValue = this.rucNumber || this.idNumber;

      this.$https
        .post("/consul/srg-verificar-contribuyente", {
          ruc: rucValue,
        })
        .then((response) => {
          if (response.data.code === 200 && response.data.preview?.validado) {
            this.requestData = {
              name: response.data.preview.razonSocial?.trim(),
              type: "ruc",
            };
            this.requesting = false;
          } else if (response.data.code === 204) {
            this.$toast.error(response.data.message, {
              position: "top-right",
              max: 10,
            });
          }
          this.requesting = false;
        })
        .catch((error) => {
          this.$toast.error("No disponemos de información", {
            position: "top-right",
            max: 10,
          });
          this.requesting = false;
        });
    },

    addProvider() {
      document.getElementById("btn-add").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i> Agregando, espere...';
      this.adding = true;
      this.requesting = true;

      const providerData = {
        providerName: this.requestData.name,
        providerDni:
          this.requestData.type === "ruc" ? this.rucNumber : this.idNumber,
        ejecutivoEmail: this.selectedEjecutivo.email,
        ejecutivoName: this.selectedEjecutivo.displayName,
        hubspotOwnerId: this.selectedEjecutivo.hubspotOwnerId,
        comercialName: this.selectedComercial
          ? this.selectedComercial.displayName
          : null,
        sala: this.selectedEjecutivo.sala,
        tokenAuth: this.tokenAuth,
      };

      // Choose whether to send RUC or ID
      if (this.requestData.type === "ruc") {
        // Use rucNumber if available, otherwise use idNumber
        providerData.providerDni = this.rucNumber || this.idNumber;
      } else if (this.requestData.type === "dni") {
        providerData.providerDni = this.idNumber;
      }

      this.$https
        .post("/hubspot/addServiceProvider", {
          ...providerData,
        })
        .then((response) => {
          this.adding = false;
          this.requesting = false;
          document.getElementById("btn-add").innerHTML = "Agregar";
          this.requestData = null;
          this.idNumber = "";
          this.rucNumber = "";
          this.selectedEjecutivo = null;
          this.selectedComercial = null;
          this.$toast.success(response.data.message, {
            position: "top-right",
            max: 10,
          });
          this.fetchProviders();
        })
        .catch((error) => {
          console.log(error);
          this.adding = false;
          this.requesting = false;
          document.getElementById("btn-add").innerHTML = "Agregar";
          this.$toast.error(error.response.data.error, {
            position: "top-right",
            max: 10,
          });
        });
    },

    fetchProviders() {
      this.loading = true;
      this.$https
        .post("/hubspot/fetchProvidersAdmin", {
          tokenAuth: this.tokenAuth,
        })
        .then((response) => {
          this.transactions = response.data.providers || [];
          this.$nextTick(() => {
            this.loading = false;
          });
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.$toast.error(error.data.message, {
            position: "top-right",
            max: 10,
          });
        });
    },

    manageProvider() {
      this.loading = true;

      const requestData = {
        tokenAuth: this.tokenAuth,
        providerDni: String(this.providerDni),
        providerStatus: this.providerStatus,
        providerName: this.providerName2,
        ejecutivoEmail: this.selectedEjecutivo?.email,
        ejecutivoName: this.selectedEjecutivo?.displayName,
        hubspotOwnerId: this.selectedEjecutivo?.hubspotOwnerId,
        comercialName: this.selectedComercial?.displayName,
        sala: this.selectedEjecutivo?.sala,
      };

      this.$https
        .post("/hubspot/manageProvider", requestData)
        .then((response) => {
          if (response.status === 200) {
            this.$toast.success("Estado del prestador actualizado", {
              position: "top-right",
              max: 10,
            });
            this.fetchProviders();
          } else {
            this.$toast.error(response.data.message, {
              position: "top-right",
              max: 10,
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$toast.error("Error al actualizar el estado", {
            position: "top-right",
            max: 10,
          });
          this.loading = false;
        });
    },

    fetchEjecutivos() {
      this.loading = true;
      this.$https
        .post("ejecutivos/getLoadEjecutivos", {
          tokenAuth: this.tokenAuth,
        })
        .then((response) => {
          this.loading = false;
          this.ejecutivos = response.data.requestList;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error(error.data.message, {
            position: "top-right",
            max: 10,
          });
        });
    },

    fetchComerciales() {
      this.loading = true;
      this.$https
        .post("ejecutivos/loadPartners", {
          tokenAuth: this.tokenAuth,
        })
        .then((response) => {
          this.loading = false;
          this.comerciales = response.data.partners;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error(error.data.message, {
            position: "top-right",
            max: 10,
          });
        });
    },

    selectEjecutivo(option) {
      this.selectedEjecutivo = option;
    },

    selectComercial(option) {
      this.selectedComercial = option;
    },

    ClickEvent(evt) {
      if (evt.target.dataset.action === "edit") {
        const dataString = evt.target.getAttribute("data-id");
        try {
          const data = JSON.parse(decodeURIComponent(dataString));

          this.providerDni2 = data.providerDni;
          this.providerName2 = data.providerName;

          // Si hay datos de ejecutivo, seleccionarlo
          if (data.ejecutivoName) {
            this.selectedEjecutivo = this.ejecutivos.find(
              (e) => e.displayName === data.ejecutivoName
            );
          }

          // Si hay datos de comercial, seleccionarlo
          if (data.comercialName) {
            this.selectedComercial = this.comerciales.find(
              (c) => c.displayName === data.comercialName
            );
          }

          this.showModal = true;
        } catch (e) {
          console.error("Error al parsear el JSON:", e);
        }
      }
    },

    handleAction(actionType, data) {
      if (actionType === "edit") {
        this.showModal = true;
      }
    },

    updateProvider() {
      this.$https
        .post("/hubspot/fetchUpdateProvider", {
          tokenAuth: this.tokenAuth,
          providerDni: this.providerDni2,
          providerName: this.providerName2,
          ejecutivoName: this.selectedEjecutivo
            ? this.selectedEjecutivo.displayName
            : null,
          ejecutivoEmail: this.selectedEjecutivo
            ? this.selectedEjecutivo.email
            : null,
          sala: this.selectedEjecutivo ? this.selectedEjecutivo.sala : null,
          hubspotOwnerId: this.selectedEjecutivo
            ? this.selectedEjecutivo.hubspotOwnerId
            : null,
          comercialName: this.selectedComercial
            ? this.selectedComercial.displayName
            : null,
        })
        .then((response) => {
          this.$toast.success(response.data.message, {
            position: "top-right",
            max: 10,
          });
          this.showModal = false;
          this.selectedEjecutivo = null;
          this.selectedComercial = null;
          this.fetchProviders();
        })
        .catch((error) => {
          this.$toast.error(error.response.data.error, {
            position: "top-right",
            max: 10,
          });
        });
    },
  },

  mounted() {
    this.fetchProviders();
    this.fetchEjecutivos();
    this.fetchComerciales();

    $(document).off("click", ".activarSwitch");
    $(document).on("click", ".activarSwitch", (evt) => {
      const providerDni = $(evt.target).data("providerdni");
      const isActive = $(evt.target).prop("checked");

      // Find the provider data from the transactions array
      const provider = this.transactions.find(
        (p) => p.providerDni === providerDni
      );

      if (provider) {
        this.providerStatus = isActive ? true : false;
        this.providerDni = providerDni;
        this.providerName2 = provider.providerName;
        this.selectedEjecutivo = {
          email: provider.ejecutivoEmail,
          displayName: provider.ejecutivoName,
          hubspotOwnerId: provider.hubspotOwnerId,
          sala: provider.sala,
        };
        this.selectedComercial = {
          displayName: provider.comercialName,
        };

        this.manageProvider();
      } else {
        console.error("Provider not found:", providerDni);
        this.$toast.error("Error: No se encontró el prestador", {
          position: "top-right",
          max: 10,
        });
      }
    });

    document.addEventListener("click", this.ClickEvent);
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

.my-custom-v-select {
  .vs__dropdown-toggle {
    border-radius: 0.375rem;
    border: 1px solid #ced4da;
    padding: 0.375rem 0.75rem;
    min-height: 38px;
  }

  .vs__selected {
    margin: 0;
    padding: 0;
  }

  .vs__search {
    margin: 0;
    padding: 0;
  }

  .vs__dropdown-menu {
    border-radius: 0.375rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  .vs__dropdown-option {
    padding: 0.5rem 0.75rem;
  }

  .vs__dropdown-option--highlight {
    background: #0078be;
  }
}

.form-switch {
  display: flex;
  justify-content: center;

  .form-check-input {
    width: 3em;
    height: 1.5em;
    margin-top: 0;
    cursor: pointer;

    &:checked {
      background-color: #198754;
      border-color: #198754;
    }
  }
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 120, 190, 0.05);
}

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal__content {
  padding: 1.5rem;
}

.modal-title {
  margin: 0;
  color: #333;
  font-weight: 600;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
}

.btn-close:hover {
  color: #333;
}
</style>
